import React, { useDebugValue } from 'react';
import moment from 'moment'

const Nat=({classes, record, samples, cu_numbers })=>{
    //console.log((JSON.parse(cu_numbers)).sort)
    const total=  samples && samples[0].total? samples[0].total : '';
    const box_num=  record && record.box_num? record.box_num : '';
    //const sortedNumbers = samples[0].isextra ===1 && cu_numbers? JSON.parse(cu_numbers) : cu_numbers[0].sort((a, b) => b - a)
    //console.log(sortedNumbers)
    return (
        <table className={classes.fullTable}>
            <tbody>
                <tr><td style={{height: '100px'}}>&nbsp;</td></tr>
                <tr>
                    <td >
                        <table className={classes.tableStyle}>
                        <tbody>
                            <tr>
                                <td>
                                    Date shipped: &nbsp;&nbsp;{moment(samples[0].ship_date).format('MM/DD/yyyy')}
                                </td>
                            </tr>
                            <tr><td>&nbsp;</td></tr>
                            <tr>
                                <td>
                                    Time Removed from Storage for Shipment: &nbsp;&nbsp;{samples[0].time_removed}
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                    <td align="center">
                        <table  className={classes.boxTable}>
                        <tbody>
                            <tr>
                                <td>
                                    <table className={classes.freeStyle}>
                                        <tbody >
                                        <tr><td colSpan="4">&nbsp;</td></tr>
                                        <tr>
                                            <td  style={{width: '15px'}}>&nbsp;</td>
                                            <td  style={{width: '200px'}}>Total # of Samples:</td>
                                            <td colSpan='2'>{total}</td>
                                        </tr>
                                        <tr><td colSpan="4">&nbsp;</td></tr>
                                        <tr>
                                            <td></td>
                                            <td >Plasma Bleed Date:</td>
                                            <td colSpan="2">{moment(samples[0].bleed_date).format('MM/DD/yyyy')}</td>
                                        </tr>
                                        <tr><td colSpan="4">&nbsp;</td></tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>Box Numbers(s):</td>
                                            <td colSpan='2'>{box_num}</td>
                                        </tr>
                                        <tr><td colSpan="4">&nbsp;</td></tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>Begining Plasma Bleed Number:</td>
                                            <td colSpan='2'>{ samples[0].isextra ===1 &&  samples[0].s_ucn? samples[0].s_ucn : ''}</td>
                                        </tr>
                                        <tr><td colSpan="4">&nbsp;</td></tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>Ending Plasma Bleed Number:</td>
                                            <td colSpan='2'>{samples[0].isextra ===1 && samples[0].e_ucn?  samples[0].e_ucn : ''}</td>
                                        </tr>
                                        <tr><td colSpan="4">&nbsp;</td></tr>
                                        <tr>
                                            <td></td>
                                            <td>Initial:</td>
                                            <td>__________________________</td>
                                            <td>Date:</td>
                                            <td>__________________________</td>
                                        </tr>
                                        <tr><td colSpan="4">&nbsp;</td></tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            
                        </tbody>
                        </table>
                    </td>
                </tr>
                <tr><td>&nbsp;</td></tr>
                <tr>
                    <td>
                    <table className={classes.tableStyle}>
                        <tbody>
                        <tr>
                            <td  style={{width: '15px'}}>&nbsp;</td>
                            <td  style={{width: '200px'}}>Comments:</td>
                            <td  style={{borderBottom: '1px solid'}} ></td>
                            <td  style={{width: '15px'}}>&nbsp;</td>
                        </tr>
                        <tr><td colSpan="4">&nbsp;</td></tr>
                        <tr>
                            <td colSpan="2"></td>
                            <td  style={{borderBottom: '1px solid'}} ></td>
                            <td  style={{width: '15px'}}>&nbsp;</td>
                        </tr>
                        </tbody>
                    </table>
                    </td>
                </tr>
                <tr>
                    <td style={{verticalAlign: 'top'}}>
                    <table className={classes.subBody} >
                        <tbody>
                        <tr>
                            <td >&nbsp;</td>
                        </tr>
                        </tbody>
                    </table>
                    </td>
                </tr>
            </tbody>

        </table>
    )
}

export default Nat

